<template>
  <div class="container center">
    <img src="../../assets/Escape/cegp-enigme_full.png" alt />
    <div @click="$emit('close')" class="close">❌</div>
  </div>
</template>

<script>
export default {
  name: "LivingRoomEnigme",
  components: {
  }
}
</script>

<style scoped>
.container {
  background: white;
  overflow: scroll;
  position: relative;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
</style>
